import React, { useState } from "react";
import classes from "./welcomeSection.module.css";
import Button from "../../containers/button/button";
import SummerCloud from "../../../assets/images/summr-cloud.png";
import WinterCloud from "../../../assets/images/winter-cloud.png"
import FootballCloud from "../../../assets/images/football-cloud.png"
import Title from '../../containers/title/title';
import SafetyModal from "../../containers/safetyModal/safetyModal";
import { getImageUrl } from "../../../utils/imageUrl";
const WelcomeSection = (props) => {
    const [showSafety, setShowSafety] = useState(false);
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString("en-US", { month: "short", day: "numeric" });
      };
    return (
        <div className={classes.Container}>
            <Title camp={props.camp} title={props.title} />
            <div className={classes.DarkEffect} />
            <div className={classes.Background} style={{backgroundImage: `url(${getImageUrl(props.info?.image)})`}}>
                <div>
                    <div className={classes.Image}>
                        <img src={props.camp === 'winter' ? WinterCloud : props.camp === 'summer' ? SummerCloud : FootballCloud} alt="cloud" />
                    </div>
                    <div className={classes.CloudContent}>
                        <div>{props.info?.name}</div>
                        <div>From {formatDate(props.info?.date_range?.start)} to {formatDate(props.info?.date_range?.end)}</div>
                    </div>
                    <div className={classes.LeftContent}>
                        <p>{props.info?.description}</p>
                        <Button content={parseInt(localStorage.getItem('language')) === 1 
                        ? "Read More About Safety" 
                        :  "اقرأ المزيد عن السلامة"} onClick={() => setShowSafety(true)}/>
                    </div>
                </div>
            </div>
            {showSafety && <SafetyModal setShowSafety={setShowSafety}/>}
        </div>
    )
}

export default WelcomeSection;